import React from 'react';
import { Pagination } from 'semantic-ui-react';
import { MPFIconButton } from '../UI';
import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';

const PortalPagination = ({ ...props }) => {
  return (
    <>
      {props.batching && (
        <div className="mpf-pagination container__fluid">
          <div className="pagination__container--full">
            <nav aria-label="Pagination" className="mpf-pagination__itens">
              <Pagination
                activePage={props.currentPage}
                totalPages={Math.ceil(props.totalItems / props.defaultPageSize)}
                onPageChange={props.onPaginationChange}
                firstItem={null}
                lastItem={null}
                pageItem={{
                  className: 'mpf-pagination__item item',
                }}
                prevItem={{
                  content: (
                    <MPFIconButton
                      as="span"
                      icon={<CaretLeftIcon />}
                      variant="outline"
                      size="m"
                      shape="square"
                    />
                  ),
                  icon: true,
                  'aria-disabled': !props.batching.prev,
                  className: `mpf-pagination__control${
                    !props.batching.prev ? ' disabled' : ''
                  }`,
                }}
                nextItem={{
                  content: (
                    <MPFIconButton
                      as="span"
                      icon={<CaretRightIcon />}
                      variant="outline"
                      size="m"
                      shape="square"
                    />
                  ),
                  icon: false,
                  'aria-disabled': !props.batching.next,
                  className: `mpf-pagination__control${
                    !props.batching.next ? ' disabled' : ''
                  }`,
                }}
              />
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

export default PortalPagination;
